import axiosInstance from '../../lib/axios';

export const fetchActivities = async (params = {}) => {
  const response = await axiosInstance.get('/activities/', { params });
  return response.data;
};

export const fetchActivityById = async (id) => {
  const response = await axiosInstance.get(`/activities/${id}/`);
  return response.data;
};

export const fetchTemplateVariables = async () => {
  const response = await axiosInstance.get('/activities/template-variables/');
  return response.data;
};

export const createActivity = async (data) => {
  const response = await axiosInstance.post('/activities/', data);
  return response.data;
};

export const updateActivity = async (id, data) => {
  const response = await axiosInstance.patch(`/activities/${id}/`, data);
  return response.data;
};

export const deleteActivity = async (id) => {
  const response = await axiosInstance.delete(`/activities/${id}/`);
  return response.data;
};
